import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import Layout from './components/Layout';
import AuthCallback from './components/AuthCallback';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PaymentResult from './pages/PaymentResult';
import Explorar from './pages/Explorar';
import EventDetail from './pages/EventDetail';
import Profile from './pages/Profile';
import OrganizerDashboard from './pages/OrganizerDashboard';
import AdminPanel from './pages/AdminPanel';
import Favoritos from './pages/Favoritos';
import './App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payments/success" element={<PaymentResult result="success" />} />
      <Route path="/payments/pending" element={<PaymentResult result="pending" />} />
      <Route path="/payments/failure" element={<PaymentResult result="failure" />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/explorar" element={<Explorar />} />
        <Route path="/eventos/:id" element={<EventDetail />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/favoritos" element={<Favoritos />} />
        <Route path="/organizador" element={<OrganizerDashboard />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
